import dayjs from 'dayjs';
import { addNotify } from 'features/notify';
import { reformatNumber } from 'shared/helpers/formatNumber';
import { getErrorMessage } from 'shared/helpers/getErrorMessage';
import { convertFiltersStatistic } from '../model/convertFilters';
import { fillMissingDates } from 'shared/helpers/fillMissingDates';

const actionTypes = {
  ACTION_PROCESSING: 'statistic/ACTION_PROCESSING',
  GET_STATISTIC: 'statistic/GET_STATISTIC',
  CLEAR_STATISTIC: 'statistic/CLEAR_STATISTIC',
  GET_BALANCE_STATISTIC: 'statistic/GET_BALANCE_STATISTIC',
};

const fmt = 'YYYY-MM-DD HH:mm:ssZ';

const comparisonTypeConverter = type => {
  switch (type) {
    case 'activeUser':
      return 'active_users';
    case 'totalBets':
      return 'total_bets';
    case 'totalWin':
      return 'total_win';
    case 'totalNetwin':
      return 'total_netwin';
    case 'margin':
      return 'margin';
    default:
      return null;
  }
};

const setActionProcessing = actionProcessing => {
  return async dispatch => {
    dispatch({
      type: actionTypes.ACTION_PROCESSING,
      payload: {
        [actionTypes.ACTION_PROCESSING]: { actionProcessing },
      },
    });
  };
};

const getBalanceStatistic =
  ({ filters }) =>
    async (dispatch, getState, extra) => {
      const { api } = extra;

      const { isAuth } = getState().auth;
      if (!isAuth) return;

      dispatch(setActionProcessing(true));

      const response = await api.statistic.getBalanceStatistic({ formData: filters });

      if (response.success) {
        dispatch({
          type: actionTypes.GET_BALANCE_STATISTIC,
          payload: {
            [actionTypes.GET_BALANCE_STATISTIC]: {
              balanceStatistic: response.data,
            },
          },
        });
      } else {
        const { locale } = getState().locale;
        const errorMessage = getErrorMessage(locale, response);
        dispatch(addNotify(errorMessage, 'error'));
      }

      // if (callback) callback(response.success ? response.data : null);
      dispatch(setActionProcessing(false));
    };

const getStatistic =
  ({ filters, id, isComparisonMode, comparisonType, callback }) =>
    async (dispatch, getState, extra) => {
      const { api } = extra;
      const { isAuth } = getState().auth;
      if (!isAuth) return;

      dispatch(setActionProcessing(true));

      const convertedFilters = convertFiltersStatistic({
        isComparisonMode,
        to: filters.to,
        from: filters.from,
        is_user_ranking: filters.isUserRanking,
        metric_name: comparisonTypeConverter(comparisonType),
      });

      const response = await api.statistic.getStatistic({ formData: convertedFilters, id });

      if (response.success) {
        const curItems = response.data?.totalMetricStatistic?.currentPeriod?.totalByDate || [];
        const prevItems = response.data?.totalMetricStatistic?.previousPeriod?.totalByDate || [];

        const start = dayjs.utc(filters.from).startOf('day');
        const end = dayjs.utc(filters.to).startOf('day');

        // Длина периода без включения последнего дня (13–20 => 7 дней, без 20)
        const shiftDays = end.diff(start, 'day');

        // Сдвигаем previousPeriod ВПЕРЁД на shiftDays
        const prevShifted = prevItems.map(it => {
          const src = typeof it.date === 'string' ? dayjs.utc(it.date, fmt, true) : dayjs.utc(it.date);
          const originalDate = src.startOf('day').format(fmt);
          const shifted = src.startOf('day').add(shiftDays, 'day').format(fmt);
          return { ...it, date: shifted, originalDate };
        });

        const currentFilled = fillMissingDates({
          items: curItems,
          from: filters.from,
          to: filters.to,
          emptyItem: { count: 0 },
          itemFormat: fmt,
          rangeFormat: fmt,
          outputFormat: fmt,
          inclusiveEnd: false, // <-- не включаем последний день
        });

        const previousFilled = fillMissingDates({
          items: prevShifted,
          from: filters.from,
          to: filters.to,
          emptyItem: { count: 0 },
          itemFormat: fmt,
          rangeFormat: fmt,
          outputFormat: fmt,
          inclusiveEnd: false, // <-- не включаем последний день
        });

        const previousFilledFixed = previousFilled.map(it => {
          if (it.originalDate && it.originalDate !== it.date) return it;

          const orig = dayjs.utc(it.date, fmt, true).subtract(shiftDays, 'day').format(fmt);
          return { ...it, originalDate: orig };
        });

        const formattedResponse = {
          ...response,
          data: {
            ...response.data,
            totalMetricStatistic: {
              ...response.data.totalMetricStatistic,
              currentPeriod: {
                ...response.data.totalMetricStatistic.currentPeriod,
                totalByDate: currentFilled,
              },
              previousPeriod: {
                ...response.data.totalMetricStatistic.previousPeriod,
                totalByDate: previousFilledFixed,
              },
            },
          },
        };

        dispatch({
          type: actionTypes.GET_STATISTIC,
          payload: {
            [actionTypes.GET_STATISTIC]: {
              statistic: formattedResponse.data,
            },
          },
        });
      } else {
        const { locale } = getState().locale;
        const errorMessage = getErrorMessage(locale, response);
        dispatch(addNotify(errorMessage, 'error'));
        dispatch({ type: actionTypes.CLEAR_STATISTIC });
      }

      if (callback) callback(response.success ? response.data : null);
      dispatch(setActionProcessing(false));
    };

export { getStatistic, getBalanceStatistic, actionTypes };
